<script setup>
import { WButton } from '@alice-health/wonderland-vue'
import { ref } from 'vue'

import Logger, { EventModel, EventName } from '@/wrappers/logger'
import { useStore } from '@/wrappers/store'

import DalyaRecommendationError from '../../atoms/dalyaRecommendation/DalyaRecommendationError.vue'

const { mapActions } = useStore()
const { getDalyaRecommendation } = mapActions('dalyaRecommendation')

const props = defineProps({
  channelId: {
    type: String,
    default: null
  },
  personId: {
    type: String,
    default: undefined
  },
  clinicalRecordId: {
    type: String,
    default: null
  },
  showOnlyButton: {
    type: Boolean,
    default: false
  },
  calledBy: {
    type: String,
    required: true
  }
})
const showRecommendationError = ref(false)

const emit = defineEmits(['updateDalyaRecommendation', 'updateStatus'])

const updateDalyaRecommendation = async () => {
  showRecommendationError.value = false

  emit('updateStatus', {
    isLoading: true,
    hasError: false
  })

  Logger.addLog(EventName.USER_INTERACTION, {
    model: EventModel.APPOINTMENT,
    modelId: props.clinicalRecordId,
    data: {
      context: 'dalya-recommendation',
      action: 'get-recommendation',
      value: props.calledBy
    }
  })

  const payload = {
    appointment_id: props.clinicalRecordId,
    channel_id: props.channelId
  }

  const [hasError, data] = await getDalyaRecommendation({
    personId: props.personId,
    payload: payload
  })

  if (hasError) {
    emit('updateStatus', {
      isLoading: false,
      hasError: true
    })
    showRecommendationError.value = true
    return
  }

  emit('updateStatus', {
    isLoading: false,
    hasError: false
  })
  emit('updateDalyaRecommendation', data)
}
</script>

<template>
  <div v-if="!showRecommendationError" class="recommendation-button">
    <WButton
      variant="primary"
      icon="icUpdate"
      icon-position="trailing"
      @click="updateDalyaRecommendation"
    >
      Atualizar Recomendação
    </WButton>
  </div>
  <DalyaRecommendationError
    v-else
    :show-only-button="props.showOnlyButton"
    @try-again="updateDalyaRecommendation"
  />
</template>

<style>
.recommendation-button {
  padding-top: var(--gl-spacing-06);
}
</style>
